/**
 * ghr-fee-nad-cart-autobuild.js
 *
 * Purpose:
 * - For email traffic only (URL flag), auto-build cart with:
 *   - GHR 90-day as subscription (selling_plan)
 *   - NAD+7 as a free gift line (discount code applied via /discount/1Shop)
 *
 * Safety:
 * - Runs only on /cart when query contains gift=1shop and gender=men|women
 * - Idempotent: checks cart contents before adding
 * - Catches errors; never blocks default cart UI
 */
(function () {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    var url = new URL(window.location.href);
    var normalizedPath = (url.pathname || '').replace(/\/+$/, '') || '/';
    if (normalizedPath !== '/cart') return;

    var giftFlag = (url.searchParams.get('gift') || '').toLowerCase();
    var gender = (url.searchParams.get('gender') || '').toLowerCase();

    if (giftFlag !== '1shop') return;
    if (gender !== 'men' && gender !== 'women') return;

    var loadingEl = document.getElementById('ghr-fee-nad-loading');
    function showLoading() {
      if (!loadingEl) return;
      loadingEl.hidden = false;
      document.documentElement.classList.add('ghr-fee-nad-lock');
      document.body.classList.add('ghr-fee-nad-lock');
    }
    function hideLoading() {
      if (!loadingEl) return;
      loadingEl.hidden = true;
      document.documentElement.classList.remove('ghr-fee-nad-lock');
      document.body.classList.remove('ghr-fee-nad-lock');
    }

    var CONFIG = {
      men: {
        ghrVariantId: 42569874374892,
        ghrSellingPlanId: 10548674796,
        nadVariantId: 46915013509356,
      },
      women: {
        ghrVariantId: 42825573368044,
        ghrSellingPlanId: 10549231852,
        nadVariantId: 46848546930924,
      },
    };

    var cfg = CONFIG[gender];
    if (!cfg) return;

    // Prevent loops if something is wrong.
    if (sessionStorage.getItem('ghr_fee_nad_autobuild_done') === gender) return;

    function toNum(v) {
      var n = Number(v);
      return isFinite(n) ? n : null;
    }

    function cartHasVariant(cart, variantId) {
      if (!cart || !Array.isArray(cart.items)) return false;
      return cart.items.some(function (it) {
        var id = toNum(it.variant_id || it.id);
        return id === variantId && (it.quantity || 0) > 0;
      });
    }

    function cartHasGhrWithPlan(cart, variantId, sellingPlanId) {
      if (!cart || !Array.isArray(cart.items)) return false;
      return cart.items.some(function (it) {
        var id = toNum(it.variant_id || it.id);
        var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan
          ? toNum(it.selling_plan_allocation.selling_plan.id)
          : null;
        return id === variantId && sp === sellingPlanId && (it.quantity || 0) > 0;
      });
    }

    function fetchJson(urlStr) {
      return fetch(urlStr, { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
    }

    function postAdd(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      }).then(function (r) {
        // Shopify returns 200 JSON on success; error JSON on failure.
        return r.json();
      });
    }

    function delay(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    (async function run() {
      var cart = await fetchJson('/cart.js');

      var needsGhr = !cartHasGhrWithPlan(cart, cfg.ghrVariantId, cfg.ghrSellingPlanId);
      var needsNad = !cartHasVariant(cart, cfg.nadVariantId);

      // Nothing to do.
      if (!needsGhr && !needsNad) {
        sessionStorage.setItem('ghr_fee_nad_autobuild_done', gender);
        hideLoading();
        return;
      }

      showLoading();

      // Add subscription GHR first (so the offer condition is met).
      if (needsGhr) {
        await postAdd({
          id: cfg.ghrVariantId,
          quantity: 1,
          selling_plan: cfg.ghrSellingPlanId,
        });
        // Small delay so Shopify updates cart state consistently across themes/apps.
        await delay(200);
      }

      // Add NAD gift (one-time line).
      if (needsNad) {
        await postAdd({
          id: cfg.nadVariantId,
          quantity: 1,
        });
        await delay(200);
      }

      sessionStorage.setItem('ghr_fee_nad_autobuild_done', gender);

      // Reload cart so the theme renders both items + discount correctly.
      window.location.replace('/cart' + url.search);
    })().catch(function () {
      hideLoading();
      // Never break the cart experience.
    });
  } catch (e) {
    // Never break the cart experience.
  }
})();

